import React, {useContext, useEffect, useRef, useState} from "react";
import {useParams} from "react-router-dom";
import {Box, Button, Card, CardContent, Grid2 as Grid, IconButton, Paper, TextField, Typography, useColorScheme} from "@mui/material";
import {DarkModeRounded, LightModeRounded} from "@mui/icons-material";
import {checkMobileValid} from "../../helper/utils";
import {login, registerWithInviteCode, sendSms} from "../../network/api/account.api";
import {connect} from "react-redux";
import {authActions} from "../../helper/redux/actions/authActions";
import {ErrorContext} from "../../components/GympinPagesProvider";

function normalizeInviteCode(raw) {
    return String(raw || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 9);
}

function isInviteCodeValid(raw) {
    return /^[A-Z0-9]{8,9}$/.test(normalizeInviteCode(raw));
}

function Login(props) {
    const { mode, systemMode, setMode } = useColorScheme();
    const isDark = (mode === "system" ? systemMode : mode) === "dark";
    const error = useContext(ErrorContext);
    const params = useParams();
    const timerRef = useRef(null);
    const [mobileNumber, setMobileNumber] = useState({value: params?.phoneNumber});
    const [disableSendBtn, setDisableSendBtn] = useState(true);
    const [sendBtnText, setSendBtnText] = useState("ارسال کد ورود");
    const [disablePhoneNumber, setDisablePhoneNumber] = useState(false);
    const [registered, setRegistered] = useState(true);
    const [fullName, setFullName] = useState({});
    const [disableFullName, setDisableFullName] = useState(false);
    const [inviteCode, setInviteCode] = useState({ value: "" });
    const [disableInviteCode, setDisableInviteCode] = useState(false);
    const [disableRegisterBtn, setDisableRegisterBtn] = useState(true);
    const [sentCode, setSentCode] = useState(false);
    const [code, setCode] = useState({});
    const [disableCode, setDisableCode] = useState(false);
    const [disableLoginBtn, setDisableLoginBtn] = useState(true);
    const [isSmartiz, setIsSmartiz] = useState(false);
    const [loginLoading, setLoginLoading] = useState(false);
    const loginLockRef = useRef(false);


    useEffect(() => {
        if (code?.value?.length == 4) {
            loginByNumber(null);
        }
    }, [code]);

    useEffect(() => {
        if (params?.code == "smartispay") {
            setInviteCode({ value: "CGF153DS", ok: true });
            setIsSmartiz(true);
        } else if (params?.code) {
            const normalized = normalizeInviteCode(params.code);
            setInviteCode({
                value: normalized,
                ok: isInviteCodeValid(normalized)
            });
            setRegistered(false);
        }
    }, [params]);


    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, []);

    function sendMessage(e) {
        if (e && e.preventDefault) e.preventDefault();
        if (!checkMobileValid(mobileNumber?.value)) {
            error.showError({message: "شماره همراه صحیح نیست"});
            return;
        }
        var count = 120;
        setDisableSendBtn(true);
        sendSms({
            "phoneNumber": mobileNumber.value.toString(),
            Application: "WEBAPP"
        })
            .then((data) => {
                if (timerRef.current) clearInterval(timerRef.current);
                timerRef.current = setInterval(() => {
                    if (count > 0) {
                        count--;
                        setSendBtnText("ارسال مجدد : " + count);
                        setSentCode(true);
                    } else {
                        if (timerRef.current) clearInterval(timerRef.current);
                        setSendBtnText("ارسال مجدد ");
                        setDisableSendBtn(false);
                        setSentCode(false);
                    }
                }, 1000);
            })
            .catch((err) => {
                setDisableSendBtn(false);
                try {
                    if (err?.response?.data?.Error?.code === 1102) {
                        setDisableSendBtn(true);
                        setDisablePhoneNumber(true);
                        setRegistered(false);
                        error.showError({ message: "این شماره هنوز ثبت نشده. نام و کد معرف را وارد کنید." });
                    } else
                        error.showError({message: err.response.data.Message});
                } catch (f) {
                    error.showError({message: "اتصال به شبکه را بررسی نمایید",});
                }
            })
    }

    function register(e) {
        registerWithInviteCode({
            PhoneNumber: mobileNumber?.value,
            FullName: fullName?.value,
            InvitedBy: isSmartiz?"CGF153DS":(inviteCode?.value)
        }).then((data) => {
            sendMessage(e);
            setRegistered(true);
        }).catch(e => {
            try {
                error.showError({message: e.response.data.Message});
            } catch (f) {
                error.showError({message: "خطای نامشخص",});
            }
        });
    }


    function changeMobileNumber(e) {
        var number = e.target.value;
        if (!number.startsWith('0')) {
            setMobileNumber({helperText: "شماره همراه با 0 شروع میشود"});
            setDisableSendBtn(true);
            return;
        }
        if (number.length < 11) {
            setMobileNumber({value: number, helperText: "شماره همراه 11 رقم نیست"});
            setDisableSendBtn(true);
            return;
        }
        if (number.length > 11) {
            return;
        }
        setDisableSendBtn(false);
        setMobileNumber({value: number, ok: true});
    }

    function changeFullName(e) {
        var name = e.target.value;
        if (name.length < 3) {
            setFullName({value: name, helperText: "نام ونام خانوادگی صحیح نیست"});
            setDisableRegisterBtn(true);
            return;
        }
        if (!name.includes(' ')) {
            setFullName({value: name, helperText: "هم نام و هم نام خانوادگی باید وارد شود"});
            setDisableRegisterBtn(true);
            return;
        }
        if (name?.split(' ')[1].length < 3) {
            setFullName({value: name, helperText: "نام خانوادگی باید وارد شود"});
            setDisableRegisterBtn(true);
            return;
        }
        if (name.length > 30) {
            return;
        }
        setFullName({value: name, ok: true});
        setDisableRegisterBtn(!isInviteCodeValid(inviteCode?.value));
    }

    function changeInviteCode(name) {
        const normalized = normalizeInviteCode(name);
        const ok = isInviteCodeValid(normalized);
        setInviteCode({
            value: normalized,
            ok,
            helperText: normalized.length === 0 || ok ? "" : "کد معرف باید ۸ یا ۹ کاراکتر حرف و عدد باشد"
        });
        setDisableRegisterBtn(!(ok && fullName.ok));
    }

    function changeCode(e) {
        var name = e.target.value;
        if (name.length < 4) {
            setCode({value: name, helperText: "کد صحیح نیست"});
            setDisableLoginBtn(true);
            return;
        }
        if (name.length > 4) {
            return;
        }
        setDisableLoginBtn(false);
        setCode({value: name, ok: true});
    }

    function loginByNumber(e) {
        e?.preventDefault();
        if (loginLockRef.current) return;
        if (!code?.value || String(code.value).length < 4) return;
        loginLockRef.current = true;
        setLoginLoading(true);
        login({
            username: mobileNumber.value,
            password: code.value,
            Application: "WEBAPP"
        }).then((data) => {
            const resData = data?.data?.Data;
            const token = resData?.Token || resData?.token;
            const refreshToken = resData?.RefreshToken || resData?.refreshToken;
            props.SetUser(resData);
            if (token) props.SetToken(token);
            if (refreshToken) props.SetRefreshToken(refreshToken);
        }).catch((err) => {
            try {
                error.showError({message: err.response.data.Message});
            } catch (f) {
                error.showError({message: "اتصال به شبکه را بررسی نمایید",});
            }
        }).finally(() => {
            loginLockRef.current = false;
            setLoginLoading(false);
        });
    }

    return (
        <>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                sx={{
                    minHeight: "100vh",
                    position: "relative",
                    backgroundImage: isDark
                        ? "linear-gradient(rgba(11, 15, 25, 0.88), rgba(11, 15, 25, 0.88)), url('/assets/images/loginbgloop.jpg')"
                        : "linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), url('/assets/images/loginbgloop.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}
            >
                {/* باکس تغییر تم در گوشه راست بالا */}
                <Box
                    sx={{
                        position: "absolute",
                        top: { xs: 16, sm: 24 },
                        insetInlineStart: { xs: 16, sm: 24 },
                        zIndex: 10,
                        bgcolor: isDark ? "rgba(21, 29, 46, 0.85)" : "rgba(255, 255, 255, 0.85)",
                        backdropFilter: "blur(12px)",
                        borderRadius: "14px",
                        border: "1px solid",
                        borderColor: isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.08)",
                        boxShadow: isDark ? "0 8px 24px rgba(0, 0, 0, 0.4)" : "0 8px 24px rgba(0, 0, 0, 0.08)",
                        p: 0.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.25s ease"
                    }}
                >
                    <IconButton
                        onClick={() => setMode(isDark ? "light" : "dark")}
                        title={isDark ? "تغییر به حالت روشن" : "تغییر به حالت تاریک"}
                        size="small"
                        sx={{
                            width: 38,
                            height: 38,
                            borderRadius: "10px",
                            bgcolor: isDark ? "rgba(251, 191, 36, 0.12)" : "rgba(99, 102, 241, 0.08)",
                            color: isDark ? "#fbbf24" : "#6366f1",
                            transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                                bgcolor: isDark ? "rgba(251, 191, 36, 0.22)" : "rgba(99, 102, 241, 0.16)",
                                transform: "rotate(15deg) scale(1.08)"
                            },
                            "&:active": {
                                transform: "scale(0.92)"
                            }
                        }}
                    >
                        {isDark ? <LightModeRounded sx={{ fontSize: 20 }} /> : <DarkModeRounded sx={{ fontSize: 20 }} />}
                    </IconButton>
                </Box>

                <Grid>
                    <Card
                        elevation={isDark ? 8 : 5}
                        sx={{
                            borderRadius: "28px",
                            m: 3,
                            maxWidth: 360,
                            bgcolor: "background.paper",
                            border: "1px solid",
                            borderColor: "divider",
                            boxShadow: isDark
                                ? "0 16px 40px -8px rgba(0, 0, 0, 0.6)"
                                : "0 16px 40px -8px rgba(0, 0, 0, 0.12)",
                            overflow: "hidden"
                        }}
                    >
                        <Paper
                            elevation={0}
                            sx={{
                                mx: "auto",
                                width: 160,
                                bgcolor: isDark ? "#121212" : "#1e1e1e",
                                border: "1px solid",
                                borderColor: isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.15)",
                                borderTop: "none",
                                px: 3,
                                py: 1.8,
                                borderRadius: "0 0 28px 28px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: isDark
                                    ? "0 8px 24px -4px rgba(0, 0, 0, 0.6), 0 0 12px rgba(231, 51, 62, 0.15)"
                                    : "0 8px 20px -4px rgba(0, 0, 0, 0.25)"
                            }}
                        >
                            <Box
                                component="img"
                                src="/assets/images/gympinTypoLight.svg"
                                alt="GymPin"
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    display: "block",
                                    filter: isDark ? "drop-shadow(0 2px 6px rgba(231, 51, 62, 0.3))" : "none"
                                }}
                            />
                        </Paper>
                        <CardContent>
                            {!isSmartiz && <>
                                <Typography color="text.primary" sx={{mt: 1, fontWeight: 800}} variant={"h5"}>خوش آمدید</Typography>
                                <Typography color="text.secondary" sx={{mt: 1, lineHeight: 1.8}} variant={"body2"}>شماره موبایل را وارد کنید.</Typography></>}
                            {isSmartiz && <>
                                <Grid sx={{mt:2}} container spacing={1} justifyContent={"start"} direction={"row"} alignItems={"center"}  >
                                    <img src={"/assets/images/smartiz-picto.png"} width={"39px"} height={"28px"} />

                                    <Typography color="text.primary" sx={{ fontWeight: 800}} variant={"h5"}>
                                        {"کاربر اسمارتیز خوش آمدید"}
                                    </Typography>
                                </Grid>
                                <Typography color="text.secondary" sx={{mt: 1, lineHeight: 1.8}} variant={"body2"}>شماره ثبت‌شده در اسمارتیز را وارد کنید.</Typography>
                            </>}

                            <TextField
                                variant="outlined"
                                type="text"
                                sx={{mt: 3}}
                                value={mobileNumber?.value || ""}
                                onChange={(e) => {
                                    changeMobileNumber(e)
                                }}
                                inputProps={{inputMode: 'numeric', style: {letterSpacing: "0.5rem", textAlign: "center", direction: "ltr"}}}
                                label={"شماره همراه"}
                                placeholder={"09_________"}
                                disabled={disablePhoneNumber}
                                error={mobileNumber?.helperText || false}
                                helperText={mobileNumber?.helperText || " "}
                                fullWidth
                            />
                            <TextField
                                variant="outlined"
                                type="text"
                                sx={{mt: 1}}
                                value={fullName?.value || ""}
                                onChange={(e) => {
                                    changeFullName(e)
                                }}
                                hidden={registered}
                                label={"نام و نام خانوادگی"}
                                disabled={disableFullName}
                                error={fullName?.helperText || false}
                                helperText={fullName?.helperText || " "}
                                fullWidth
                            />
                            <TextField
                                variant="outlined"
                                type="text"
                                sx={{mt: 1}}
                                value={inviteCode?.value || ""}
                                onChange={(e) => {
                                    changeInviteCode(e.target.value)
                                }}
                                hidden={registered||isSmartiz}
                                label={"کد معرف"}
                                inputProps={{
                                    inputMode: "text",
                                    autoCapitalize: "characters",
                                    autoCorrect: "off",
                                    spellCheck: false,
                                    style: {letterSpacing: "0.15rem", textAlign: "center", direction: "ltr"}
                                }}
                                disabled={disableInviteCode}
                                error={inviteCode?.helperText || false}
                                helperText={inviteCode?.helperText || " "}
                                fullWidth
                            />
                            {registered && <Button onClick={(e) => sendMessage(e)} disabled={disableSendBtn || loginLoading} size={"large"} fullWidth
                                                   variant={"contained"}>{sendBtnText}</Button>}
                            {!registered && <Button onClick={(e) => register(e)} disabled={disableRegisterBtn} size={"large"} fullWidth
                                                    variant={"contained"}>ثبت نام</Button>}

                            <TextField
                                variant="outlined"
                                type="number"
                                sx={{mt: 3}}
                                value={code?.value || ""}
                                onChange={(e) => {
                                    changeCode(e)
                                }}
                                hidden={!sentCode}
                                label={"کد ورود"}
                                inputProps={{inputMode: 'numeric', style: {letterSpacing: "0.5rem", textAlign: "center", direction: "ltr"}}}
                                disabled={disableCode || loginLoading}
                                error={code?.helperText || false}
                                helperText={code?.helperText || " "}
                                fullWidth
                            />
                            {sentCode && <Button onClick={(e) => loginByNumber(e)} disabled={disableLoginBtn || loginLoading} size={"large"} fullWidth
                                                 variant={"contained"}>{loginLoading ? "در حال ورود..." : "ورود"}</Button>}
                        </CardContent>
                    </Card>
                </Grid>

            </Grid>
            {/*{RegisterPopup()}*/}
        </>
    );
}

export default connect(null, authActions)(Login)
